export enum FieldStringFormatType {
    mask = 'mask',
    regex = 'regex',
}
